import { gql, useQuery } from '@apollo/client'
import { RouteComponentProps } from '@reach/router'
import { DashboardTitle } from './DashboardTitleContext'

const batchQuery = gql`
  query BatchById($batchId: ID!) {
    batchById(batchId: $batchId) {
      id
      number
      status
      sentEmail {
        id
        status
        submittedAt
      }
      orders {
        totalCount
      }
      history {
        createdAt
        ... on BatchEmailEvent {
          csv
          mandrillId
        }
      }
    }
  }
`

const formatDate = (dateString: string) => new Date(dateString).toLocaleString()

const BatchEmailEvent = ({ event }) => {
  return (
    <>
      Mandrill ID: {event.mandrillId}
      <br />
      <textarea rows={6} style={{ width: '100%', padding: 7 }} readOnly value={event.csv} />
    </>
  )
}

const eventsToComponents = {
  BatchEmailEvent,
}

const eventsToTitles = {
  BatchEmailEvent: 'Batch email sent',
}

const Batch = ({ batchId }: RouteComponentProps<{ batchId: string }>) => {
  const { loading, error, data } = useQuery(batchQuery, {
    variables: { batchId },
  })

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error! {error.message}</div>
  }

  const batch = data.batchById

  return (
    <div className="container">
      <DashboardTitle title={`Batch ${batch.number}`} />

      <table className="table is-striped">
        <tbody>
          <tr>
            <td>Status</td>
            <td>{batch.status}</td>
          </tr>
          {batch.sentEmail && (
            <tr>
              <td>Mandrill state</td>
              <td>{batch.sentEmail.status}</td>
            </tr>
          )}
          {batch.sentEmail && (
            <tr>
              <td>Email sent at</td>
              <td>{formatDate(batch.sentEmail.submittedAt)}</td>
            </tr>
          )}
        </tbody>
      </table>

      <h2 className="title is-4">Orders</h2>

      <div>
        <strong>{batch.orders.totalCount} </strong> orders in this batch
      </div>

      <h2 className="title is-4 mt-4">History</h2>
      <table className="table is-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Event Type</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {batch.history.map((event) => {
            const Component = eventsToComponents[event.__typename]

            return (
              <tr key={event.createdAt}>
                <td>{formatDate(event.createdAt)}</td>
                <td>{eventsToTitles[event.__typename]}</td>
                <td>
                  <Component event={event} />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Batch
